var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prayer",on:{"click":_vm.stateChange}},[_c('div',{staticClass:"prayer-icon-container p-3",class:{'active' : _vm.active}},[_c('img',{staticClass:"prayer-icon rounded img-fluid",attrs:{"loading":"lazy","sizes":"100%, 100%","src":_vm.iconSource,"title":_vm.prayer.name,"alt":_vm.prayer.name}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85076372","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/prayer/Prayer.vue
// module id = null
// module chunks = 